import { render } from "./IconMenuAddressBook.vue?vue&type=template&id=78593f66"
import script from "./IconMenuAddressBook.vue?vue&type=script&lang=ts"
export * from "./IconMenuAddressBook.vue?vue&type=script&lang=ts"
script.render = render

export default script